var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"loan_layout"}},[_c('Topbar'),_c('div',{staticClass:"page-wrapper"},[_c('PageError',{attrs:{"is-shown":true,"reload":false,"message":"Page Not Found"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }